import { requestApi } from '@app/api';
import { withForm } from '@app/api/paths';

export interface Draft {
  id: string;
  name: string;
  createdAt: string; // ISO string
  updatedAt: string; // ISO string
}

// eslint-disable-next-line import/prefer-default-export
export async function copyDraft(workspaceId: string, id: string) {
  const response = await requestApi<Draft>({
    url: withForm(`/workspaces/${workspaceId}/drafts/${id}/copy`),
    method: 'POST',
    credentials: true,
  });
  return response.data;
}
